import { render } from "./PartnerDashboardProfile.vue?vue&type=template&id=b50d7ace&scoped=true"
import script from "./PartnerDashboardProfile.vue?vue&type=script&lang=js"
export * from "./PartnerDashboardProfile.vue?vue&type=script&lang=js"

import "./PartnerDashboardProfile.vue?vue&type=style&index=0&id=b50d7ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50d7ace"]])

export default __exports__